import { parse, stringifyUrl } from "query-string";
import { useHistory as baseUseHistory } from "react-router";

export function useHistory() {
  const history = baseUseHistory();
  history.query = function (query = null, replace = false) {
    if (query == null) {
      return parse(history.location.search);
    } else {
      history.push({
        search: stringifyUrl(
          {
            url: replace ? "" : history.location.search,
            query,
          },
          {
            skipNull: true,
            skipEmptyString: true,
          }
        ),
      });
    }
  };
  return history;
}

export const getSiteName = (value) => {
  try {
    return value.split(".")[0];
  } catch {
    return value;
  }
};

export const addPriceComma = (value) => {
  return value.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const removePriceComma = (value) => {
  return value.toString().replace(/,/g, "");
};

export const addTomanPriceComma = (value) => {
  return addPriceComma(~~(value / 10));
};

export const isDigit = (value) => {
  const reg = /^[\d۰۱۲۳۴۵۶۷۸۹]*?$/;
  return !isNaN(value) && reg.test(value);
};
